import styled from 'styled-components';
import {transparentize} from 'polished';
import {transition} from 'helpers/css';

export const Wrapper = styled.button`
  color: ${({theme}) => `
    ${transparentize(.7, theme.variables.color)};
  `};

  ${transition()};
  padding: 4px 0;
  column-gap: 12px;
  text-align: left;
  align-items: center;
  grid-template-columns: auto 1fr;
  display: grid;

  &:hover {
    color: ${({theme}) => `
    ${transparentize(.4, theme.variables.color)};
  `};
  }
`;
